<template>
  <v-content>
    <v-container fluid style="position: relative">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-container fluid>
              <v-card-title>      
                {{ 'Groups' | translate }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-form id="form" ref="form">
                  <v-row>
                    <v-col cols="12" sm="8" md="8">
                      <v-row v-if="errors">
                        <v-col cols="12" sm="12" md="12">
                          <v-alert
                            dense
                            v-for="(v, k) in errors"
                            :key="k"
                            outlined
                            type="error"
                          >{{ k }} {{ v }}</v-alert>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            outlined
                            :label="'Group name' | translate"
                            v-model="group_name"
                            name="group_name"
                            autocomplete="off"
                            :rules="groupnameRules"
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>                            
                          </v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete
                              v-model="users_data"
                              :items="groupusers"
                              item-value="user_id"
                              item-text="name"
                              :label="'Users' | translate"
                              :rules="userRules"
                              outlined
                              chips
                              small-chips
                              multiple
                              required
                              :no-data-text="$t('No data available')"
                            >
                            <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                            </template>                              
                            </v-autocomplete>
                        </v-col>
                      </v-row>


                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete
                              v-model="courses_data"
                              :items="courses"
                              item-value="course_id"
                              item-text="course_name"
                              :label="'Courses' | translate"
                              :rules="courseRules"
                              outlined
                              chips
                              small-chips
                              multiple
                              required
                              :no-data-text="$t('No data available')"
                            >
                            <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                            </template>  
                            </v-autocomplete>
                        </v-col>
                      </v-row>


                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete
                              v-model="group_admins"
                              :items="groupusers"
                              item-value="user_id"
                              item-text="name"
                              :label="'Group admins' | translate"
                              :rules="groupadminRules"
                              outlined
                              chips
                              small-chips
                              multiple
                              required
                              :no-data-text="$t('No data available')"
                            >
                            <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                            </template>                              
                            </v-autocomplete>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete
                              v-model="documents"
                              :items="personaldocuments"
                              item-value="perdoc_id"
                              item-text="perdoc_name"
                              :label="'User documents' | translate"
                              outlined
                              chips
                              small-chips
                              multiple
                              :no-data-text="$t('No data available')"
                            >
                            <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                            </template>                              
                            </v-autocomplete>
                        </v-col>
                      </v-row>

                    </v-col>
                    <v-col cols="12" sm="4" md="4"></v-col>
                  </v-row>
                </v-form>
                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  class="mx-2"
                  v-if="group_id != ''"
                  @click="submit"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  class="mx-2"
                  v-if="group_id"
                  @click="update"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
              </v-card-text>
            </v-container>
          </v-card>
       </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>  

<script>
import {
  ADD_GROUP,
  FETCH_INDIVIDUAL_GROUP,
  FETCH_PERSONAL_DOCUMENTS,
  FETCH_GROUP_USERS,
  UPDATE_GROUP,
  FETCH_COURSES,
  RESET_STATE
} from "@/store/actions.type";
import {  SET_SNACKBAR, SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
import store from "@/store"
import { mapState } from "vuex"
import { mapGetters } from "vuex"
export default {
  name: "addeditGroups",
  async beforeRouteUpdate(to, from, next) {
    await store.dispatch(RESET_STATE)
    return next();
  },
  async beforeRouteEnter(to, from, next) {
    Promise.all([
        await store.dispatch(FETCH_GROUP_USERS, ''),
        await store.dispatch(FETCH_COURSES,''),
        await store.dispatch(FETCH_PERSONAL_DOCUMENTS)
        
    ]).then(() => {
        store.commit(SET_LOADING, false)
      })     
    if (to.params.id) {
      await store.dispatch(FETCH_INDIVIDUAL_GROUP, to.params.id)
      
    }
    store.commit(SET_ROUTER_ENTER, false)

    return next();
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(RESET_STATE)
    next();
  },
  computed: {
    ...mapGetters(['individualgroup', 'personaldocuments','groupusers','courses', 'currentUser', 'curLanguage']),
    ...mapState({
      errors: state => state.groups.grouperrors
    }),
    groupnameRules(){  return [v => !!v || "Group name is required"]},
    userRules(){ return [v => !!(v && v.length) || "Users are required"]},
    groupadminRules(){ return [v => !!(v && v.length) || "Group admin is required"]},
    courseRules(){ return [v => !!(v && v.length) || "Course are required"]},
    documentRules(){return [v => !!(v && v.length)|| "User documents are required"]},


  },
  created () {
    if(this.currentUser.roles.includes(1) == false){
      this.$router.push('/learningcenter');
    }
    if(Object.keys(this.individualgroup).length >0){
      this.group_id = this.individualgroup.group_id
      this.group_name =   this.individualgroup.group_name
      this.users_data =   this.individualgroup.users
      this.group_admins   =   this.individualgroup.group_admins
      this.courses_data   =   this.individualgroup.courses
      this.documents      = this.individualgroup.documents
    }
  },
  data: function() {
    return {
      group_id: null,
      group_name: null,
      group_admins:[],
      users_data:[],
      courses_data: [],
      documents: [],
    }
  },
  methods : {
    submit: function() {
      if (this.$refs.form.validate()) {
        let data = {
            group_name: this.group_name,
            group_id: this.group_id,
            users: this.users_data,
            courses: this.courses_data,
            group_admins: this.group_admins,
            documents: this.documents,
          }

        if(this.documents.length == 0){
          data = {
            group_name: this.group_name,
            group_id: this.group_id,
            users: this.users_data,
            courses: this.courses_data,
            group_admins: this.group_admins,
          }
        }

        this.$store
          .dispatch(ADD_GROUP, data)
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              store.commit(SET_SNACKBAR, {status: true, message: 'Group created successfully'})
              store.commit(SET_LOADING, false)
              this.$router.push({ name: "groups" });
            }
            else{
              store.commit(SET_LOADING, false)
            }
          });
      }
    },
    update: function() {
      if (this.$refs.form.validate()) {

        let data = {
            group_name: this.group_name,
            group_id: this.group_id,
            users: this.users_data,
            courses: this.courses_data,
            group_admins: this.group_admins,
            documents: this.documents,            
            _method: "put"
          };

        if(this.documents.length == 0){
          data = {
            group_name: this.group_name,
            group_id: this.group_id,
            users: this.users_data,
            courses: this.courses_data,
            group_admins: this.group_admins,
            _method: "put"
          }
        }

        this.$store
          .dispatch(UPDATE_GROUP, data)
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              store.commit(SET_SNACKBAR, {status: true, message: 'Group updated successfully'})
              store.commit(SET_LOADING, false)
              this.$router.push({ name: "groups" })
            }
            else{
              store.commit(SET_LOADING, false)
            }
          });
      }
    }

  },
};
</script>